import React from "react";
import "./SmallCard.scss";

/**
 * SmallCard - Summary card with icon, title, value and optional change indicator.
 * Fits parent width (e.g. col-md-2, col-md-3). Supports custom height, colors, and content.
 *
 * @param {string} title - Label (e.g. "TOTAL FILES & FOLDERS")
 * @param {string|number} value - Main value (e.g. "12,642")
 * @param {string} [height] - Card height (e.g. "140px", "100px", "auto")
 * @param {string} [minHeight] - Minimum height (e.g. "80px")
 * @param {string} [maxHeight] - Maximum height (e.g. "200px")
 * @param {string} [backgroundColor] - Card background (e.g. "#fff", "#f8f9fa")
 * @param {string} [iconColor] - Icon fill color; if iconBgColor not set, also used as icon area background (lighter)
 * @param {string} [iconBgColor] - Icon area background (e.g. light blue); optional
 * @param {string} [fontColor] - Color for title and value text
 * @param {string} [changeIndicator] - Optional pill text (e.g. "+8%")
 * @param {string} [icon] - Font Awesome icon class (e.g. "fa fa-folder", "fa fa-lock")
 * @param {string} [className] - Extra class for the card wrapper
 * @param {string} [subtitle] - Optional small label below title (e.g. "Active / Inactive")
 */
const SmallCard = ({
  title,
  value,
  height,
  minHeight,
  maxHeight,
  backgroundColor,
  iconColor,
  iconBgColor,
  fontColor,
  changeIndicator,
  icon,
  className = "",
  subtitle,
}) => {
  const cardStyle = {};
  if (height) cardStyle.height = height;
  if (minHeight) cardStyle.minHeight = minHeight;
  if (maxHeight) cardStyle.maxHeight = maxHeight;
  if (backgroundColor) cardStyle.backgroundColor = backgroundColor;
  if (fontColor) cardStyle.color = fontColor;

  const iconBoxStyle = {};
  if (iconBgColor) iconBoxStyle.backgroundColor = iconBgColor;
  else if (iconColor) iconBoxStyle.backgroundColor = iconColor;
  if (iconColor) iconBoxStyle.color = iconColor;

  return (
    <div
      className={`small-card ${className}`.trim()}
      style={cardStyle}
      role="article"
    >
      <div className="small-card__icon-wrap" style={iconBoxStyle}>
        <span className="small-card__icon">
          <i className={icon && typeof icon === "string" ? icon : "fa fa-folder"} aria-hidden="true" />
        </span>
      </div>
      {changeIndicator != null && changeIndicator !== "" && (
        <span className="small-card__change">{changeIndicator}</span>
      )}
      <div className="small-card__body">
        <div className="small-card__title">{title}</div>
        {subtitle && <div className="small-card__subtitle">{subtitle}</div>}
        <div className="small-card__value">{value}</div>
      </div>
    </div>
  );
};

export default SmallCard;
